import { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { format, subDays } from 'date-fns';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import fetch from 'features/common/fetch';
import { productDomainsIdsMapper } from 'features/views/dashboard/todaysUrgencies/constants';
import { getUnpaidFirstPaymentCountByProductDomain } from 'features/views/dashboard/todaysUrgencies/selectors';

import UrgencyTemplate from './UrgencyTemplate';

export const UnpaidFirstPayment = ({ productDomain }) => {
	const navigate = useNavigate();

	const unpaidFirstPaymentCount = useSelector((state) =>
		getUnpaidFirstPaymentCountByProductDomain(state, productDomain),
	);
	const hasUnpaidFirstPayments = unpaidFirstPaymentCount > 0;

	const linkText = useMemo(
		() => getMessage('dashboard:todaysUrgencies.policy', { count: unpaidFirstPaymentCount }),
		[unpaidFirstPaymentCount],
	);

	const handleRedirect = useCallback(() => {
		const policyProductDomainId = productDomainsIdsMapper[productDomain];
		const dateFrom = format(subDays(new Date(), 25), 'yyyy-MM-dd');
		const dateTo = format(subDays(new Date(), 20), 'yyyy-MM-dd');
		let search;

		if (policyProductDomainId === productDomainsIdsMapper.ZP) {
			search = `?policyStatus=6&policyPaymentStatus=1&productDomain=${policyProductDomainId}&policyValueDateFrom=${dateFrom}&policyValueDateTo=${dateTo}`;
		} else {
			search = `?policyStatus=6&policyPaymentStatus=1&productDomain=${policyProductDomainId}&policyOpenDateFrom=${dateFrom}&policyOpenDateTo=${dateTo}`;
		}

		navigate({
			pathname: '/policies',
			search,
		});
	}, [navigate, productDomain]);

	return (
		hasUnpaidFirstPayments && (
			<ComponentLoader fetchStorePath={`${fetch.constants.urls.unpayedFirstPayment}.${productDomain}`}>
				<UrgencyTemplate>
					<Typography variant="body2">
						{getMessage('dashboard:todaysUrgencies.unpaidFirstPayment', {
							productDomain: getMessage(`dashboard:todaysUrgencies.${productDomain}`),
						})}
					</Typography>
					<Link underline="none" onClick={handleRedirect} sx={{ cursor: 'pointer', fontSize: 14 }}>
						{linkText}
					</Link>
				</UrgencyTemplate>
			</ComponentLoader>
		)
	);
};

UnpaidFirstPayment.propTypes = {
	productDomain: PropTypes.string,
};

export default UnpaidFirstPayment;
